export const bg = {
  "nav.check_booking": "Провери Резервация",
  "nav.admin": "Админ",
  "nav.book_now": "Резервирай Сега",
  "nav.driver": "Шофьор",
  "hero.badge": "Транспорт за J1 Студенти",
  "hero.title": "Easy Transportation",
  "hero.subtitle": "Вашият Надежден Транспорт от Чикаго до Уисконсин",
  "hero.description": "Безопасен, надежден и достъпен транспорт за студенти с виза J1. Резервирайте днес!",
  "hero.book_trip": "Резервирай Пътуване",
  "hero.check_status": "Провери Статус на Резервация",
  "pricing.title": "Цени за Транспорт",
  "pricing.subtitle": "Всички цени в USD",
  "pricing.ohare_mke": "Трансфер (O'Hare / Milwaukee)",
  "pricing.midway": "Трансфер (Midway)",
  "pricing.madison": "Madison до Wisconsin Dells",
  "pricing.return": "Отстъпка за Връщане",
  "pricing.shared": "Споделено Пътуване",
  "pricing.private": "Частно Пътуване",
  "pricing.per_person": "на човек",
  "pricing.after_deposit": "с депозит от $20",
  "pricing.without_deposit": "без депозит",
  "pricing.flat_rate": "фиксирана цена",
  "pricing.per_suitcase": "На куфар",
  "pricing.carry_on": "Ръчен багаж",
  "pricing.free": "БЕЗПЛАТНО",
  "pricing.with_shipping": "Връщане + изпращане с нас",
  "pricing.special_deal": "Специална Оферта!",
  "pricing.midway_contact": "Свържете се с нас за цени за Midway (MDW)",
  "pricing.waterpark_note": "Цените може да се различават за Three Bears Water Park или други дестинации.",
  "pricing.contact_us": "Свържете се с нас",
  "pricing.guidelines_title": "Как Работят Нашите Цени",
  "pricing.guidelines_deposit": "Депозит от $20 на човек осигурява вашата резервация. Остатъкът се плаща в деня на пътуването.",
  "pricing.guidelines_shared": "2 или повече пътници, пътуващи на един и същ ден до едно и също летище, получават споделена цена.",
  "pricing.guidelines_solo": "Самостоятелните пътници (единствен пътник този ден) може да имат малко по-висока цена.",
  "pricing.guidelines_suitcase": "1 куфар е безплатен при обратни пътувания. Всеки допълнителен куфар е $5.",
  "pricing.guidelines_payment": "Приемаме плащания с Карта, Кеш и Zelle.",
  "requirements.title": "Изисквания за Резервация",
  "requirements.pickup": "Предлагаме трансфери два пъти в рамките на 24 часа, освен ако не е уведомено друго. Планирайте и резервирайте предварително!",
  "requirements.deposit": "Изисква се невъзстановим депозит от $3,200 JMD (или $20 USD) преди да бъдете добавени към графика.",
  "requirements.seamless": "Осигурете своето място, като направите депозита предварително, за да избегнете закъснения.",
  "requirements.final_payment": "Оставащият баланс трябва да бъде платен преди качване в превозното средство.",
  "special.title": "Дестинацията Не Е в Списъка?",
  "special.description": "Предлагаме специални пътувания до дестинации извън нашите редовни маршрути. Свържете се с нас за оферта!",
  "special.call": "Обади се",
  "special.whatsapp": "WhatsApp",
  "features.title": "Защо Easy Transportation?",
  "features.subtitle": "Доверено от хиляди J1 студенти всяко лято",
  "features.easy_booking": "Лесна Резервация",
  "features.easy_booking_desc": "Необходим е само депозит от $3,200 JMD ($20 USD). Платете чрез превод, карта, PayPal или Zelle.",
  "features.safe": "Безопасно и Надеждно",
  "features.safe_desc": "Професионални шофьори, комфортни превозни средства и 24/7 поддръжка за J1 студенти.",
  "features.flexible": "Гъвкав График",
  "features.flexible_desc": "Резервирайте пристигания и връщания. Първият куфар е безплатен при връщане!",
  "video.badge": "Вижте Ни в Действие",
  "video.title": "Вашето Пътуване Започва Тук",
  "video.subtitle": "Гледайте J1 студенти от Ямайка и Доминиканската Република да започват приключението си",
  "video.book_now": "Резервирай Сега",
  "booking.title": "Резервирай Пътуване",
  "booking.step": "Стъпка",
  "booking.of": "от",
  "booking.trip_type": "Тип Пътуване",
  "booking.arrival": "Пристигане (Трансфер от Летище)",
  "booking.return": "Връщане (Към Летището)",
  "booking.ride_type": "Тип Услуга",
  "booking.shared_ride": "Споделено Пътуване",
  "booking.shared_desc": "Споделете с други пътници по същия маршрут",
  "booking.private_ride": "Частно Пътуване",
  "booking.private_desc": "Ексклузивно превозно средство само за вас",
  "booking.pickup_location": "Летище за Заминаване",
  "booking.select_airport": "Изберете Летище",
  "booking.travel_date": "Дата на Пътуване",
  "booking.travel_time": "Очаквано Време на Пристигане",
  "booking.departure_time": "Време на Заминаване",
  "booking.flight_number": "Номер на Полет",
  "booking.airline": "Авиокомпания",
  "booking.terminal": "Терминал на Пристигане",
  "booking.full_name": "Пълно Име",
  "booking.whatsapp": "WhatsApp Номер",
  "booking.email": "Имейл Адрес",
  "booking.housing": "Жилищна Единица",
  "booking.select_housing": "Изберете Жилище",
  "booking.custom_address": "Въведете Потребителски Адрес",
  "booking.num_passengers": "Брой Пътници",
  "booking.suitcases": "Общо Куфари",
  "booking.shipping": "Използвате ли T&M Courier Services?",
  "booking.payment": "Метод на Плащане",
  "booking.referral": "Код за Препоръка",
  "booking.next": "Напред",
  "booking.previous": "Назад",
  "booking.submit": "Завърши Резервацията",
  "booking.processing": "Обработва се...",
  "booking.start_over": "Започни Отначало",
  "booking.first_time": "За Първи Път Пътувам",
  "booking.returning": "Завръщащ се Клиент",
  "booking.confirmation_number": "Номер на Потвърждение",
  "pricing_summary.title": "Обобщение на Цените",
  "pricing_summary.trip_price": "Цена на Пътуването",
  "pricing_summary.luggage_fee": "Такса за Багаж",
  "pricing_summary.deposit": "Депозит",
  "pricing_summary.per_person": "на човек",
  "pricing_summary.discount": "Отстъпка за Препоръка",
  "pricing_summary.total_now": "Общо Дължимо Сега",
  "pricing_summary.balance": "Оставащ Баланс",
  "success.title": "Резервацията е Потвърдена!",
  "success.confirmation": "Номер на Потвърждение",
  "success.details": "Детайли на Резервацията",
  "success.whatsapp_optin": "Получавайте актуализации чрез WhatsApp",
  "success.home": "Обратно към Началната Страница",
  "driver.title": "Панел на Шофьора",
  "driver.login": "Вход за Шофьор",
  "driver.phone": "Телефонен Номер",
  "driver.pin": "ПИН Код",
  "driver.sign_in": "Влез",
  "driver.trips_today": "Днешни Курсове",
  "driver.upcoming": "Предстоящи Курсове",
  "driver.passengers": "пътници",
  "driver.suitcases": "куфари",
  "driver.navigate": "Навигирай до Точката на Вземане",
  "driver.contact": "Свържи се с Пътника",
  "driver.complete": "Завърши Курса",
  "driver.logout": "Излез",
  "driver.no_trips": "Няма планирани курсове",
  "common.loading": "Зареждане...",
  "common.error": "Нещо се обърка",
  "common.save": "Запази",
  "common.cancel": "Отмени",
  "common.close": "Затвори",
  "common.details": "Детайли",
  "common.status": "Статус",
  "common.date": "Дата",
  "common.time": "Час",
  "common.price": "Цена",
  "common.passenger": "Пътник",
  "common.passengers": "Пътници",
};
